"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay } from "swiper/modules";
import { useMediaQuery } from "react-responsive";
import Link from "next/link";
import Image from "next/image";
import { useTranslation } from "@/contexts/TranslationContext";

import "swiper/css";
import "swiper/css/effect-coverflow";

const ThreeDSlider = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const slides = isMobile
        ? [1, 2, 3, 4, 5, 6, 7].map((i) => `/themes/kulturklub/slider/mobile/${i}.webp`)
        : [1, 2, 3, 4, 5, 6, 7].map((i) => `/themes/kulturklub/slider/desktop/${i}.webp`);

    return (
        <div className="w-full mx-auto py-10 bg-[#f3f5f7] mt-[-55px] md:mt-[-140px]">
            <Swiper
                effect="coverflow"
                grabCursor={true}
                centeredSlides={true}
                slidesPerView="1"
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    0: { slidesPerView: 1 },
                    640: { slidesPerView: 1 },
                    1024: { slidesPerView: 1 },
                }}
                coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}
                modules={[EffectCoverflow, Autoplay]}
                className="mySwiper h-[90vh] md:h-screen overflow-hidden" ///// ITT ÁLLÍTOD A MAGSSÁGOT!!!!
            >
                {slides.map((src, i) => (
                    <SwiperSlide
                        key={i}
                        className={`swiper-slide w-full relative`} // Mindig teljes képernyőmagasság
                    >
                        {/* Overlay */}
                        <div
                            className="absolute inset-0 pointer-events-none z-10"
                            style={{
                                background:
                                    "radial-gradient(circle, rgba(0, 0, 0, 0.3) 10%, rgba(0, 0, 0, 0) 30%)",
                                backgroundSize: "3px 3px",
                            }}
                        ></div>

                        {/* Ken Burns effekt Image komponenssel */}
                        <div className="ken-burns w-full h-full relative">
                            <Image
                                src={src}
                                alt=""
                                width={1600}
                                height={900}
                                unoptimized
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Középre pozícionált felirat */}
                        <div className="absolute inset-0 flex items-center justify-center flex-col text-center space-y-4 z-20 animate-slide-up">
                            <h2
                                className="text-2xl md:text-6xl font-bold text-white px-4 py-2"
                                style={{
                                    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)",
                                }}
                            >
                                {t("three.d.slider.title")}
                            </h2>
                            <p
                                className="text-xl md:text-3xl font-semibold px-4 py-2"
                                style={{
                                    color: "#FF64DA",
                                    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.6)",
                                }}
                            >
                                {t("three.d.slider.slogan")}
                            </p>
                            <Link
                                href="#esemenyek"
                                onClick={(e) => {
                                    e.preventDefault();
                                    const target = document.querySelector("#esemenyek");
                                    if (target) {
                                        target.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            >
                                <button className="relative px-4 py-2 text-white border-2 rounded hover:opacity-90 bg-[#FF64DA] border-white overflow-hidden animate-pulse">
                                    <span className="relative z-10">{t("three.d.slider.button")}</span>
                                </button>
                            </Link>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <style jsx>{`
.swiper-slide {
  position: relative;
}

.swiper-slide::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.2) 10%, rgba(0, 0, 0, 0) 30%);
  pointer-events: none;
  z-index: 1; /* Az overlay a kép fölött lesz */
}

.swiper-slide img {
  position: relative;
  z-index: 0; /* A kép az overlay alatt marad */
}

.swiper-slide .slide-content {
  position: relative;
  z-index: 2; /* A szöveg és gombok az overlay fölé kerülnek */
}
`}</style>
        </div>
    );
};

export default ThreeDSlider;